import { render } from "./FooterActions.vue?vue&type=template&id=47b329b6"
import script from "./FooterActions.vue?vue&type=script&lang=js"
export * from "./FooterActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__